import React, { Component } from "react";
import Service from "../../services/nhanvienService";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Grid, Pagination, TextField } from "@mui/material";
import { Stack } from "@mui/system";
import { Edit } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import dayjs from "dayjs";
import VePhepService from "../../services/vePhepService";

import { LoaiVePheps } from "../../utils/cons";
import CuaKhauService from "../../services/cuaKhauService";
import VePhepDialog from "../vephep/VePhepDialog";
import LyDoService from "../../services/lyDoService";

const service = new Service();
const MAX_PAGE_SIZE = 10;

class NghiViecView extends Component {
  constructor(props) {
    super(props)
    this.vePhepService = new VePhepService();
    this.cuaKhauService = new CuaKhauService();
    this.lyDoService = new LyDoService();
  }

  state = {
    items: [],
    openDialog: false,
    updateModel: { name: "", isActive: true },
    permission:[],
    keyword: "",
    pageCount: 0,
    offset: 1,
    
    item: {},
    open: false,
    loaiVePheps: [],
    minDate: new Date(),
    cuaKhaus: [],
    lyDoHenLais: [],
    vePheps: []
  };

  componentDidMount = () => {
    this.search();
    this.cuaKhauService.getList({}).then((rs) => {
      this.setState({cuaKhaus: rs.items});
    });
    this.lyDoService.getList().then((rs) => {
      this.setState({lyDoHenLais: rs.items});
    });
  };

  onClose = () => {
    this.setState({open: false});
  }

  // on click edit item
  openEditDialog = (ev, item) => {
    this.vePhepService.getById(item.VePhepId).then((vePhep) => {
      vePhep.CuaKhau = this.state.cuaKhaus.filter(q => q.id === vePhep.CuaKhauId);
      vePhep.CuaKhau = vePhep.CuaKhau.length === 0 ? null : vePhep.CuaKhau[0];
      
      let open = ev !== null;
      this.setState({item: vePhep, open});
    })
  };

  handleClickClose = (ev, rs) => {
    if (rs !== "backdropClick") {
      this.setState({ openDialog: false });
    }
  };
  openDialog = (ev) => {
    this.setState({updateModel: {name: "", permission:[], isActive: true}});
    this.setState({ openDialog: true });
  };

  search = () => {
    this.loadList(1);
  }

  loadList(page = 1) {
    service.searchThoiViec(this.state.keyword,page, MAX_PAGE_SIZE).then((rs) => {
      if (!rs) {
        this.setState({items: [], pageCount: 0});
      }
      let pageCount = parseInt((rs.count / MAX_PAGE_SIZE)) + (rs.count % MAX_PAGE_SIZE === 0 ? 0 : 1);
      this.setState({items: rs.items, pageCount})
    });
    this.setState({ openDialog: false, offset: page }); 
  }

  // on click edit item
  clickEdit = (ev, item) => {
    ev.preventDefault();
    item.id = item.name;
    item.permission = item.PhongBans.map(q => q.id);
    this.setState({ updateModel: item, openDialog: true });
  };

  ongChangePageCount = (ev, page) => {
    this.loadList(page);
  }

  render() {
    return (
        <>
        <VePhepDialog
          items={this.state.vePheps}
          service={this.vePhepService}
          onChange={() => {this.search(); this.onClose()}}
          open={this.state.open}
          onClose={this.onClose}
          model={this.state.item}
          minDate={this.state.minDate}
          loaiVePheps={LoaiVePheps}
          lyDoHenLais = {this.state.lyDoHenLais}
          cuaKhaus={this.state.cuaKhaus} />
        
        <Stack spacing={2}>
          <Grid margin={1} container spacing={1}>
            <Grid item xs={9}>
              <TextField id="outlined-basic"
                fullWidth
                onChange={(ev) => {this.setState({keyword: ev.target.value})}}
                size="small" variant="outlined" sx={{float: "right"}} />
            </Grid>
            <Grid item xs={2.5}>
              <Button fullWidth variant="contained" onClick={this.search} sx={{float: "right"}}>Tìm kiếm</Button>
            </Grid>
          </Grid>

          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>STT</TableCell>
                  <TableCell>Mã nhân viên</TableCell>
                  <TableCell>Tên</TableCell>
                  <TableCell>Ngày vào làm</TableCell>
                  <TableCell>Phòng ban</TableCell>
                  <TableCell>Khu liên hợp</TableCell>
                  <TableCell>Cửa khẩu</TableCell>
                  <TableCell>Số điện thoại</TableCell>
                  <TableCell>Ngày nghỉ phép</TableCell>
                  <TableCell>Ngày hết phép</TableCell>
                  <TableCell>Ngày thôi việc</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.items.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.maNV}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{dayjs(item.ngayVaoLam).format('DD/MM/YYYY')}</TableCell>
                    <TableCell>{item.TenPhongBan}</TableCell>
                    <TableCell>{item.KhuLienHop}</TableCell>
                    <TableCell>{item.CuaKhau}</TableCell>
                    <TableCell>{item.dienThoai}</TableCell>
                    <TableCell>{dayjs(item.ngayDi).format('DD/MM/YYYY')}</TableCell>
                    <TableCell>{dayjs(item.ngayHetPhep).format('DD/MM/YYYY')}</TableCell>
                    <TableCell>{dayjs(item.ngayNghiViec).format('DD/MM/YYYY')}</TableCell>
                    <TableCell>
                    <IconButton onClick={(ev) => this.openEditDialog(ev, item)}>
                      <Edit />
                    </IconButton>
                  </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          
          <Pagination onChange={this.ongChangePageCount} sx={{display: "flex", justifyContent: "center"}} count={this.state.pageCount} variant="outlined" />
        </Stack>
        </>
    );
  }
}

export default NghiViecView;
